import sharingOptionsUi from './sharing-options-ui'

export default {
    sharingOptionsUi
}
